import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigation } from '../hooks/useNavigation';
import { useAuth } from '../hooks/useAuth';
import { pathWithEmpresa } from '../utils/companyUrl';

/**
 * Componente que maneja redirecciones automáticas basadas en roles
 * @param {Object} props - Las props del componente
 * @param {React.ReactNode} props.children - Componente hijo a renderizar
 */
const RoleBasedRedirect = ({ children }) => {
  const { isSupervisor, getDefaultRoute } = useNavigation();
  const { empresaIdFromUrl, selectedCompany } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const empresaId = empresaIdFromUrl || selectedCompany?.id;

  useEffect(() => {
    if (isSupervisor && location.pathname === '/') {
      navigate(pathWithEmpresa('/tareos', empresaId), { replace: true });
    }
  }, [isSupervisor, location.pathname, navigate, empresaId]);

  return children;
};

export default RoleBasedRedirect;